import { Injectable, ErrorHandler } from '@angular/core';
/**
 * Service is used for docker externalization.
 */
@Injectable({
  providedIn: 'root',
})
export class AppExceptionHandlingService implements ErrorHandler {
  handleError(error: Error): void {
    console.error(error);
  }
}
